// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-outstanding-balance/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { Wallet as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetOutstandingBalanceMeta: TWidgetMetaInfo = {
  name: 'Outstanding Balance',
  categories: ['Widget'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'Your outstanding unpaid balance.',
  externalDependencies: [],
}
